module.exports = __webpack_public_path__ + "static/Portfolio12-409bd9537cf0725e8122a63ceb8446f3.jpg";